import { WechatFilled } from '@ant-design/icons'
import { createStyles } from 'antd-style'

import { Qrcode } from '@eastcoal/common/components/Qrcode'
import { pick } from '@eastcoal/common/utils/object'

import { useScanQrcodeStore } from '../Store/hooks/useStore'

import { ScanQrcodeCoreProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tip: {
    fontSize: token.fontSizeSM
  },
  icon: {
    paddingInlineEnd: token.paddingXXS,
    color: token.green
  }
}))

export const ScanQrcodeCore = ({
  tip,

  /* -------------------------------------------------------------------------- */
  /*                                Qrcode Props                                */
  /* -------------------------------------------------------------------------- */
  className,
  style,
  bordered
}: ScanQrcodeCoreProps) => {
  const { qrcode, status, reloadQrcode } = useScanQrcodeStore(state =>
    pick(state, ['qrcode', 'status', 'bound', 'openId', 'reloadQrcode'])
  )

  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.container, className)} style={style}>
      <Qrcode
        bordered={bordered}
        src={qrcode}
        status={status}
        onRefresh={reloadQrcode}
      />
      <div className={styles.tip}>
        {tip ?? (
          <span>
            <WechatFilled className={styles.icon} />
            使用微信扫码并关注公众号
          </span>
        )}
      </div>
    </div>
  )
}
